"use client";
import "./homesection1.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useParams, Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

const Homesection1 = () => {
  const { t } = useTranslation("global");
  const { lang } = useParams();
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Set up intersection observer to detect when section is in view
  useEffect(() => {
    // Force animation reset when not visible
    const resetAnimation = () => {
      if (!isVisible && hasAnimated) {
        // Small delay to ensure CSS transitions reset properly
        setTimeout(() => {
          const section = sectionRef.current;
          if (section) {
            // Force a reflow to reset animations
            section.style.display = "none";
            section.style.display = "";
          }
        }, 50);
      }
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        // When section comes into view
        const isIntersecting = entry.isIntersecting;
        setIsVisible(isIntersecting);

        if (isIntersecting) {
          setHasAnimated(true);
        } else {
          // Reset animations when out of view
          resetAnimation();
        }
      },
      {
        // Trigger when at least 10% of the element is in the viewport
        threshold: 0.1,
        // Add root margin to trigger earlier/later
        rootMargin: "0px 0px -10% 0px",
      }
    );

    const currentSection = sectionRef.current;
    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, [isVisible, hasAnimated]);

  return (
    <section
      ref={sectionRef}
      className={`home-section1-container ${
        isVisible ? "animate-section" : ""
      }`}
      data-animate={isVisible ? "true" : "false"}
    >
      <div className="container">
        <header className={`heading ${isVisible ? "animate-heading" : ""}`}>
          <h1>{t("homesection1.heading")}</h1>
        </header>
        <nav className={`list-item ${isVisible ? "animate-nav" : ""}`}>
          <Link to={`/${lang}/OurServices`} onClick={scrollToTop}>
            <li>{t("navbar.services")}</li>
          </Link>
          <Link to={`/${lang}/AboutUs`} onClick={scrollToTop}>
            <li>{t("navbar.aboutUs")}</li>
          </Link>
          <Link to={`/${lang}/ContactUs`} onClick={scrollToTop}>
            <li>{t("navbar.contact")}</li>
          </Link>
        </nav>
        <div className="Boxes">
          <article
            className={`box1 ${isVisible ? "animate-box" : ""}`}
            style={{ animationDelay: "0.2s" }}
          >
            <div className="text">
              <h2>{t("homesection1.box1.title")}</h2>
              <p>{t("homesection1.box1.description")}</p>
            </div>
            <Link to={`/${lang}/OurServices`} onClick={scrollToTop}>
              <button className="button-box1">
                {t("homesection1.box1.button")}
              </button>
            </Link>
          </article>
          <article
            className={`box2 ${isVisible ? "animate-box" : ""}`}
            style={{ animationDelay: "0.4s" }}
          >
            <h2>{t("homesection1.box2.title")}</h2>
            <Link to={`/${lang}/AboutUs`} onClick={scrollToTop}>
              <button className="button-box2">
                <FontAwesomeIcon
                  icon={faAngleRight}
                  style={{ borderRadius: "50%" }}
                />
              </button>
            </Link>
          </article>

          <article
            className={`box2 ${isVisible ? "animate-box" : ""}`}
            style={{ animationDelay: "0.6s" }}
          >
            <h2>{t("homesection1.box3.title")}</h2>
            <Link to={`/${lang}/ContactUs`} onClick={scrollToTop}>
              <button className="button-box2">
                <FontAwesomeIcon
                  icon={faAngleRight}
                  style={{ borderRadius: "50%" }}
                />
              </button>
            </Link>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Homesection1;
